import { render } from "./BzListGroup.vue?vue&type=template&id=4f1fd27e&scoped=true"
import script from "./BzListGroup.vue?vue&type=script&lang=js"
export * from "./BzListGroup.vue?vue&type=script&lang=js"

import "./BzListGroup.vue?vue&type=style&index=0&id=4f1fd27e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4f1fd27e"]])

export default __exports__